import { Middleware } from 'redux'
import { ToastId } from 'containers/ToastManager/ToastContext'

import * as ActionTypes from '../actionTypes'
import { ADD, DISMISS } from '../modules/toasts'
import { Variant } from 'components/Toasts/Toast'

type ShowToast = (
  message: string,
  variant: Variant,
  autoDismiss: boolean
) => ToastId | void
type DismissToast = (id: ToastId) => void

interface Methods {
  showToast?: ShowToast
  dismissToast?: DismissToast
}

let methods: Methods = {}

const middleware: Middleware = () => next => (action: any) => {
  if (!methods.dismissToast || !methods.showToast) {
    return next(action)
  }

  const { dismissToast, showToast } = methods

  switch (action.type) {
    case ActionTypes.REQUEST_MEMBERSHIP_SUCCESS:
    case ActionTypes.ACCEPT_MEMBERSHIP_SUCCESS:
      showToast(action.payload.message, 'positive', action.payload.autoDismiss)
      break

    case ActionTypes.RESEND_VERIFICATION_EMAIL_FAILURE:
    case ActionTypes.REQUEST_MEMBERSHIP_FAILURE:
    case ActionTypes.ACCEPT_MEMBERSHIP_FAILURE:
      showToast(action.payload.message, 'negative', action.payload.autoDismiss)
      break

    case ADD:
      showToast(
        action.payload.message,
        action.payload.variant,
        action.payload.autoDismiss
      )
      break

    case DISMISS:
      dismissToast(action.payload.id)
      break
  }

  return next(action)
}

interface ToastMethods {
  showToast: ShowToast
  dismissToast: DismissToast
}

export const linkContextMethods = (externalMethods: ToastMethods) => {
  const { showToast, dismissToast } = externalMethods
  methods = { showToast, dismissToast }
}

export default middleware
